import { Database } from "lucide-react";

import { getImportStageSupportText } from "../utils/ehrImportRun";
import classes from "./EhrCsvUploadModal.module.css";

const DEFAULT_SUPPORT_TEXT = "Comparing patient dates, times, and visit codes.";

const EhrCsvProcessingStep = ({ importRun }) => {
	const progressPercent = Math.max(0, Math.min(100, Number(importRun?.progressPercent) || 0));
	const totalRecords = Number(importRun?.totalRecords) || 0;
	const stageSupportText = getImportStageSupportText(importRun?.currentStage) || DEFAULT_SUPPORT_TEXT;
	const isFailed = importRun?.status === "failed";
	const recordLabel = totalRecords > 0 ? totalRecords.toLocaleString("en-US") : "your";

	return (
		<div className={classes.processingWrap}>
			{!isFailed ? (
				<div
					aria-hidden="true"
					className={classes.processingIconRing}
					style={{ background: `conic-gradient(#27b99a ${progressPercent * 3.6}deg, #e8eef2 0deg)` }}>
					<div className={classes.processingIconInner}>
						<Database size={30} strokeWidth={1.75} />
					</div>
				</div>
			) : null}

			{isFailed ? (
				<>
					<h3 className={classes.processingTitle}>Import failed</h3>
					<p className={classes.processingSupportText}>
						{importRun?.errorMessage || "The import could not be completed. Please try again."}
					</p>
				</>
			) : (
				<>
					<h3 className={classes.processingTitle}>
						Validating {recordLabel} records against TeleTrace data...
					</h3>
					<p className={classes.processingSupportText}>{stageSupportText}</p>
				</>
			)}

			{!isFailed ? (
				<div
					aria-label={`Import progress ${progressPercent}%`}
					aria-valuemax={100}
					aria-valuemin={0}
					aria-valuenow={progressPercent}
					className={classes.processingProgressTrack}
					role="progressbar">
					<div className={classes.processingProgressFill} style={{ width: `${progressPercent}%` }} />
				</div>
			) : null}
		</div>
	);
};

export default EhrCsvProcessingStep;
